
export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  originalPrice?: number;
  rating: number;
  reviews: number;
  category: string;
  images: string[];
  isNew?: boolean;
  isFeatured?: boolean;
  stock: number;
  specs: Record<string, string>;
  reviewsList?: Review[];
  variants?: ProductVariant[];
}

export interface ProductVariant {
  id: string;
  name: string; // e.g., "Size", "Color"
  options: string[]; // e.g., ["S", "M", "L"], ["Red", "Blue"]
}

export interface SiteSettings {
  siteName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  freeShippingThreshold: number;
  heroSlides: Array<{
    title: string;
    subtitle: string;
    description: string;
    image: string;
  }>;
}

export interface Category {
  id: string;
  name: string;
  image: string;
  icon: string;
}

export interface CartItem extends Product {
  quantity: number;
  selectedVariants?: Record<string, string>; // e.g., { "Size": "M", "Color": "Red" }
}

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark'
}

export interface Review {
  id: string;
  user: string;
  rating: number;
  comment: string;
  date: string;
}
